export const OurTeam = [
    "PhoneGap App Development and IStellar are almost similar, our developers are the best PhoneGap App Developers on the industry. We hold no bars when it comes to our imagination, we also excel at creating technically sound products that help customer companies succeed in their business every day. We are confident that it is our quality team & strategic thinking that makes us truly different from the rest.",
    "As the best PhoneGap development company in India, we provide the quality app services in the worldwide mobile application development industry. To Create your mobile app, and beat your business competitors with the top features, Please contact us."
]
export const OtherMobileServices = [
    {ul: [
        {li: "React Native development",
        path: "/services/react-native-development"},
        {li: "Flutter development",
        path: "/services/flutter-development"},
        {li: "Ionic development",
        path: "/services/ionic-development"},
    ]}
]
export const OurPhoneGapServices = [
    "IStellar is a leading custom PhoneGap Application development company servicing all over the world. Our wide range of services to enterprises with respect to their business-critical data have established our esteemed image in the PhoneGap mobile development market.",
    "At IStellar, we follow the rules of Agile and Scrum Project flow strictly, this basically means that we're constantly on the lookout for better and new ways of mobile app development. Working with PhoneGap is one of our core strength as it makes the process of app development very easy for our developers!"
]
export const OurPhoneGapServicesList = [
"We keep our PhoneGap app design & development techniques, updated unique, and creative.",
"We deliver quick, efficient, and cost-effective services.",
"We serve porting services using PhoneGap from your existing web app to a high quality mobile app.",
"24x7 support, daily communications, on-time report, and build updates.",
"We deliver mobile application integration with mobile phones for augmented reality, geolocation, health monitoring and much more.",
"By using our long years of experience and skill set, we build innovative, enticing, and seamless mobile apps through PhoneGap.",
"We never accept a project without understanding what our customers want, and this is why we can fulfil the expectation of our customers.",
]
export const PhoneGapImg1 = [
    "PhoneGapImg1"
]
export const PhoneGapImg2 = [
    "PhoneGapImg2"
]